import React, { Component } from 'react';
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import classNames from 'classnames';
import { confirmAlert } from 'react-confirm-alert'; // Import

import {PatientTodaysRecordDurationDataListAction,deletePatientTodaysRecordDurationDataAction,UpdateCollectedBehaviorData} from '../../actions/BehaviourDataActions';
import { CancelButton } from '../../../../../../../../components/buttons';
import SmallLoader from '../../../../../../../../img/small-loader.gif';
import { showFormatedDateandTime } from '../../../../../../../../actions/utilAction';
import { isFloat, renderTextField } from '../../../../../../../../components/reduxFields';
import moment from 'moment';
import { change, Field, reduxForm } from 'redux-form';

class RecordDurationDataViewModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: true,
            patientId: props.patientId ? parseInt(props.patientId) : null,
            deleteModal: false,
            creadtedDate: props.creadtedDate,
            showDecimalError:false,
        }
        this.handleDurationChange = this.handleDurationChange.bind(this);
    }
   
     
    componentWillMount = () => {        
        this.props.PatientTodaysRecordDurationDataListAction(this.state.patientId, this.props.uuid, this.state.creadtedDate)
    }
   
    
    componentWillReceiveProps(nextProps) {
        (nextProps.patientTodaysRecordDurationDataList && nextProps.patientTodaysRecordDurationDataList.data.PatRecordDurationData || []).forEach((obj, index) => {
            this.props.dispatch(change('RecordDurationDataViewModalForm', `Behavior[${index}].duration`, obj.duration || 0));
        });
    }

    handleClose = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    handleDecimalPoint = (e) => {
        const { value } = e.target;
      
        // Check if the value is empty or matches the decimal format
        if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
          // Count the number of decimal points
          const decimalPoints = (value.match(/\./g) || []).length;
      
          // Allow only up to one decimal point
          if (decimalPoints <= 1) {
            this.setState({ value });
      
            // Hide the error if there is one decimal point or none
            if (this.state.showDecimalError) {
              this.setState({ showDecimalError: false });
            }
            return;
          }
        }
      
        // Show error if there are multiple decimal points
        if (!this.state.showDecimalError) {
          this.setState({ showDecimalError: true });
        }
      };
    
    handleDurationChange = (event, data, action) => {
        this.setState({ showDecimalError: false });
        this.props.UpdateCollectedBehaviorData(data.id, data.recordDurationDataDetailId, moment().format('YYYY-MM-DDTHH:mm:ss'), 0, 0, event.target.value, this.state.patientId, 'DURATION', 'DURATION', this.props.uuid, this.state.creadtedDate)
    }

    handleDeleteClick = (e, Obj) => {
        this.setState({
            deleteModal : true
        })
        
        confirmAlert({
            title: 'Delete Selected Duration Data',
            message: 'Are you sure you want to delete this Duration Data?',
            buttons: [
              {
                label: 'Yes',
                onClick: () => {
                    this.props.deletePatientTodaysRecordDurationDataAction(Obj.recordDurationDataDetailId, this.state.patientId, this.props.uuid, this.state.creadtedDate)
                    this.setState({
                        deleteModal: false
                    })
                }

              },
              {
                label: 'No',
                onClick: () => {
                    this.setState({
                        deleteModal: false
                    })
                }
              }
            ],
            closeOnClickOutside: false, //By Default it is true
            closeOnEscape: false,       //By Default it is true
          });
    }

    renderLoading = () => {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    renderData = (patientTodaysRecordDurationDataList) => {
        patientTodaysRecordDurationDataList = patientTodaysRecordDurationDataList || [];
        if (!patientTodaysRecordDurationDataList.length) {
            return (
                <tr>
                    <td colSpan="4">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return patientTodaysRecordDurationDataList.map((Obj, index) => {
            return (
                <tr key={index}>
                    <td>{Obj.behaviorCategoryName}</td>
                    <td>{showFormatedDateandTime(Obj.sessionDate)}</td>
                    {/* <td>{Obj.duration}</td> */}
                    <td>
                        <Field
                            name={`Behavior[${index}].duration`}
                            type="text"
                            maxLength="5"
                            label="Duration In Min."
                            component={renderTextField}
                            onChange={this.handleDecimalPoint}
                            normalize={isFloat}
                            disabled={ this.props.updatePermissionBehavior ? false: true}
                            onBlur={(event) => this.handleDurationChange(event, Obj, 'DURATION')}
                        />
                        <p style={{fontSize:"12px"}}>(Ex: 15 sec = 0.25 min)</p>
                        <p>{this.state.showDecimalError ? <span style={{ color: "rgb(244, 67, 54)", fontSize: "12px" }}>Invalid decimal number</span> : null}</p>
                    </td>
                    <td>
                    {this.props.deletePermissionBehavior && <button onClick={(e) => this.handleDeleteClick(e, Obj)} title="Delete" type="button" className="tbactionbtn redfont">
                        <i className="fa fa-trash-o" aria-hidden="true"></i>
                    </button>}
                    </td>
                </tr>
            )
        })
    }

    renderPatientRecordDurationDataList = () => {
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        const { patientTodaysRecordDurationDataList } = this.props;
        let PatientTodaysRecordDurationDataList = (patientTodaysRecordDurationDataList && patientTodaysRecordDurationDataList.data.PatRecordDurationData) || [];
        return (
            <div className="readmin-panel mt-10">
                <div className="panel-body">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="table-responsive mt-15">
                                <table className={tableClass}>
                                    <thead>
                                        <tr>
                                            <th width="40%">Category Name</th>
                                            <th width="25%">Session Date</th>
                                            <th width="25%">Duration</th>
                                            <th width="10%">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.renderData(PatientTodaysRecordDurationDataList)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const actions = [<CancelButton className="mr-15" onTouchTap={this.handleClose} />];
        return (
            <div>
                {!this.state.deleteModal && <Dialog
                    className="custom_modal"
                    title="Undo Past Data"
                    modal={false}
                    open={this.state.open}
                    actions={actions}
                    autoScrollBodyContent={true}
                >
                    {this.renderLoading()}
                    {this.renderPatientRecordDurationDataList()}
                </Dialog>}
            </div>
        )
    }
}
RecordDurationDataViewModal = reduxForm({
    form: 'RecordDurationDataViewModalForm',
    //enableReinitialize: true,
})(RecordDurationDataViewModal);

function mapStateToProps(state) {
    return {       
        loading: state.patientBehaviourData.loading,
        patientTodaysRecordDurationDataList: state.patientBehaviourData.patientTodaysRecordDurationDataList
    }
}

export default connect(mapStateToProps, { PatientTodaysRecordDurationDataListAction, deletePatientTodaysRecordDurationDataAction,UpdateCollectedBehaviorData })(RecordDurationDataViewModal)




// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/components/RecordDuration/RecordDurationDataViewModal.js